import React, { memo } from "react";
import ListHeader from '../../../../../shared/components/ListHeader';
import ListContainer from '../../../../../shared/components/ListContainer';
import styles from "./listSimcardToUpload.module.scss";
import { useTranslation } from "react-i18next";

const ListGpsDevicesToUpload = ({ itemsAvailableToInsert, itemsUnavailableToInsert }) => {

    const { t } = useTranslation(["devices", "home"]);

    return (
        <div className={styles.wrapper} >

            {
                itemsUnavailableToInsert && itemsUnavailableToInsert.length > 0 &&
                <>
                    <ListHeader className={`${styles.header} ${styles.error}`}>
                        {`${itemsUnavailableToInsert.length} ${t("home:simcards")} ${t("home:with_conflict")}`}
                    </ListHeader>

                    <ListHeader className={styles.subHeader}>
                        <div> ICCID </div>
                        <div> {t('home:number')} </div>
                        <div> {t('home:status')} </div>
                    </ListHeader>

                    <ListContainer>
                        {itemsUnavailableToInsert.map((item, index) => (
                            <div key={index}>
                                <div>{item.iccid}</div>
                                <div>{item.number}</div>
                                <div>{item.status_code}</div>
                            </div>
                        ))}
                    </ListContainer>
                </>
            }

            {
                itemsAvailableToInsert && itemsAvailableToInsert.length > 0 &&
                <>
                    <ListHeader className={`${styles.header} ${styles.success}`}>
                        {`${itemsAvailableToInsert.length} ${t("home:devices")} ${t("home:redy_to_upload")}`}
                    </ListHeader>

                    <ListHeader className={styles.subHeader}>
                        <div> ICCID </div>
                        <div> {t('home:number')} </div>
                        <div> {t('home:status')} </div>
                    </ListHeader>

                    <ListContainer>
                        {itemsAvailableToInsert.map((item, index) => (
                            <div key={index}>
                                <div>{item.iccid}</div>
                                <div>{item.number}</div>
                                <div>{item.status_code}</div>
                            </div>
                        ))}
                    </ListContainer>
                </>
            }

        </div>
    )
}

export default memo(ListGpsDevicesToUpload);